import { supabaseWithoutCSRF } from "../supabaseClient";

const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const generateChecksPdf = async (body, fileName) => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const { data: sessionData } = await supabaseWithoutCSRF.auth.getSession();
  const accessToken = sessionData?.session?.access_token;
  if (!supabaseUrl || !supabaseAnonKey || !accessToken) {
    throw new Error("You need to be signed in to generate checks.");
  }

  const response = await fetch(`${supabaseUrl}/functions/v1/generate-checks`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      apikey: supabaseAnonKey,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    let message = "Could not generate the PDF.";
    try {
      const payload = await response.json();
      if (payload?.error) message = payload.error;
    } catch {
      message = (await response.text()) || message;
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  downloadBlob(blob, fileName);
};

export const downloadCheckPdf = async ({
  tournamentId,
  templateId,
  grouping,
  checkDate,
}) => {
  await generateChecksPdf(
    {
      mode: "checks",
      tournamentId,
      templateId,
      grouping,
      checkDate,
    },
    "tournament-checks.pdf"
  );
};

export const downloadCalibrationPdf = async (templateId) => {
  await generateChecksPdf(
    {
      mode: "calibration",
      templateId,
    },
    "check-calibration.pdf"
  );
};
